import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";
import { SelectOption } from "../../../../../../../../shared/interfaces";

interface StepTwoFormContextProps {

    stepTwoForm:                        FormInstance<any> | undefined;

    activeKey:                          any;
    setActiveKey:                       Dispatch<SetStateAction<any>>;

    tabs:                               Array<any>;
    setTabs:                            Dispatch<SetStateAction<Array<any>>>;
    addNewTab:                          (id?: number) => void;
    duplicateTab:                       (id?: number) => void;
    removeTab:                          (id?: any) => void;

    personalEffectsFormValues:                     any;
    setPersonalEffectsFormValues:                  Dispatch<SetStateAction<any>>;

    showModal:                          boolean;
    setShowModal:                       Dispatch<SetStateAction<boolean>>;
    
    keyTabToDelete:                     number | null;
    setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;

    planOptionsBySelectedPlan:          Array<SelectOption>;
    filterPlansByPlanTypeSelected:      () => void;

    areTabActionsAllowed:               boolean;
    planTypeSelected:                   'A' | 'C';
    setPlanTypeSelected:                Dispatch<SetStateAction<'A' | 'C'>>;
    resetTabs:                          (unconfirmedPlanType: 'A' | 'C') => void;

    isPlanTypeADisabled:                boolean;
    isPlanTypeCDisabled:                boolean;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);